import axios from "axios";
import {  localStorageVar } from "../constant";
import { DataEncription, Decrypt } from "../services/data-encription";
import { getFromLocalStorage, removeFromLocalStorage } from "../hooks/useLocalStorage";
import createFilterData from "../utilities/createFilterData";
import { toast } from "react-toastify";
import { store } from "../store";
import { logoutSession } from "../redux/common/action";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
//import { autoSpell } from "./utiles";
export const fetchProductApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/product.json`);
};

export const fetchChatApi1 = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/chatMember.json`);
};

export const fetchChatApi2 = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/chat.chats.json`);
};

export const fetchEmailApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/email.json`);
};

export const fetchBookmaekApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/bookmark.json`);
};

export const fetchTodoApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/todo.json`);
};

export const fetchTaskApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/task.json`);
};

export const fetchProjectApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/project.json`);
};

// EPORTAL 2.0
export const fetchAllUsersDataApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/project.json`);
};

// CUSTUM USE
export const middlewareEncryption = async (api, data = {}, head = true,multiMediaHeaders= false,isLogoutTrigger = false) => {
    console.log( 'Payload:', data);
    try {
        if (head) {
            const token = localStorage.getItem("token")
            let headers 
            if(multiMediaHeaders){
              headers = {
                    'Authorization': token,
                    'Content-Type': 'multipart/form-data'
                }
                let result = await axios.post(`${process.env.REACT_APP_SERVER_URL}${api}`, data, { headers })
                return result
            }else{
                headers = {
                    'Authorization': token
                }
                let result = await axios.post(`${process.env.REACT_APP_SERVER_URL}${api}`, DataEncription(data), { headers });
                console.log(result?.data,"result?.data?.result")
            if (result?.data?.result) {
                result.data.result = Decrypt(result.data.result)
            }
            if(process.env.NODE_ENV?.toLowerCase() == "development"){
            console.log(result, "result2")
            }
            return result
            }
            
        }
        else {
            let result = await axios.post(`${process.env.REACT_APP_SERVER_URL}${api}`, DataEncription(data));
            if ("result" in result.data) {
                result.data.result = Decrypt(result.data.result)
            }
            if(process.env.NODE_ENV?.toLowerCase() == "development"){
            console.log(result, "result2")
            }
            return result
        }
    } catch (error) {
        if(!isLogoutTrigger){
            if (error.response?.status == 401) {
            
                if(error.response?.data?.error == "Your session has expired, please try logging in again."){
                    clientLogout(null,true);
                }
            }
            // if (error.response?.status == 500) {
            
            //     // toast.error("Something went wrong")
            //     // console.log(error.response?.data?.error,"500 error status code error message")
            //     // window.location.href = '/dashboard/default';
            //     return
            // }
            // else {
                if(error.response?.data){
                    if ("result" in error.response?.data) {
                        error.response.data.result = Decrypt(error.response.data.result)
                    }
                }
               
                throw error;
            // }
        }else{
            clientLogout(null);
        }
        
    }
}



export const middlewareDecryption = async (api, type = "API") => {
    try {
        const token = localStorage.getItem("token");
        const headers = {
            'Authorization': token
        };
        let result = await axios.get(`${process.env.REACT_APP_SERVER_URL}${api}`, { headers }); 
        if ("result" in result.data) {
            result.data.result = Decrypt(result.data.result);
        }
        if(process.env.NODE_ENV?.toLowerCase() == "development"){
        console.log(result,"result")
        }
        return result;
    } catch (error) {
        if (error.response?.status == 401 ) {
            // const navigate = useNavigate();
         
            if(error.response?.data?.error == "Your session has expired, please try logging in again."){
                clientLogout(null,true);
            }
            let sessionErrorMessage
            if(error.response?.data?.error){
                sessionErrorMessage = error.response.data.error;
            }else{
                sessionErrorMessage = "Session time out";
            }
            
            localStorage.setItem("sessionErrorMessage", sessionErrorMessage);
            // const { performLogoutAction } = ReduxCtmDispatch();
            // performLogoutAction()
            

           

            //window.location.href = `${process.env.PUBLIC_URL}/pages/errors/error401`;
        }else {
            throw error;
        }
        // else if (error.response?.status == 500) {
        //     toast.error("Something went wrong")
        //     console.log(error.response?.data?.error,"500 error status code error message")
        //     window.location.href = '/dashboard/default';
        //     return
        // }
        
    }
}
  

export const clientLogout = async (navigate,isSessionTimeOut=false) => {
    if(isSessionTimeOut){
            Swal.fire({
                icon: 'info',   
                title: 'Session timed out'
            });
    }
    await store.dispatch(logoutSession())

    let user = localStorage.getItem("user");
    let browserId = localStorage.getItem("browserId");
    let isRememberMe = localStorage.getItem("isRememberMe");
    let sessionErrorMessage = localStorage.getItem("sessionErrorMessage");

    // Clear local storage
    // localStorage.clear();
    removeFromLocalStorage(localStorageVar.USER_VAR)
    removeFromLocalStorage(localStorageVar.TOKEN_VAR)

    localStorage.setItem("sessionErrorMessage", sessionErrorMessage);

    if (isRememberMe == "true") {
        localStorage.setItem("user", user);
        localStorage.setItem("browserId", browserId);
        localStorage.setItem("isRememberMe", isRememberMe);
        if(navigate){
            navigate(`${process.env.PUBLIC_URL}/rememberMe`);
        }else{
            window.location.href = `${process.env.PUBLIC_URL}/rememberMe`;
        }
    }
    else {
        if(navigate){
            navigate(`${process.env.PUBLIC_URL}/login`);
        }else{
            // setTimeout(() => {
                window.location.href = `${process.env.PUBLIC_URL}/login`;
            // }, 3000);
            // window.location.href = `${process.env.PUBLIC_URL}/login`;
        }
    }
}


export const userLogin = async (data) => {
    return middlewareEncryption("/api/users/login", data, false)
};

export const requestResetPassword = (data) => {
    return middlewareEncryption("/api/users/requestResetPassword", data, false)
};

export const consumeResetPassword = (data) => {
    return middlewareEncryption("/api/users/consumeResetPassword", data, false)
};

export const checkValidToken = (data) => {
    return axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/checkValidToken/${data}`);
};

export const VerifyEmailOtp = (data) => {
    return middlewareEncryption("/api/users/consumeVerifyEmailOtp", data, false)
};

export const VerifyPhoneOtp = (data) => {
    return middlewareEncryption("/api/users/consumeVerifyPhoneOtp", data, false)
};
export const LoginOtp = (data) => {
    return middlewareEncryption("/api/users/consumeLogInOtp", data, false)
};

export const resendPhoneVerificationOtp = (data) => {
    return middlewareEncryption("/api/users/resendPhoneVerificationOtp", data, false)
};

export const resendEmailVerificationOtp = (data) => {
    return middlewareEncryption("/api/users/resendEmailVerificationOtp", data, false)
};

export const resendLoginEmailOtp = (data) => {
    return middlewareEncryption("/api/users/resendLoginEmailOtp", data, false)
};

export const changePasswordApi = (data) => {
    return middlewareEncryption("/api/users/changePassword", data)
};

export const getProfile = () => {
    return middlewareDecryption(`/api/users/getProfile`);
};

export const updateProfile = (data) => {
    return middlewareEncryption("/api/users/updateProfile", data)
};

export const logoutUser = async (navigate) => {
    let data = {
        "type": "all"
    }
    await middlewareEncryption("/api/users/logOut", data,true,false,true).then((res) => {
        if(res.data?.code == 200){
            
            clientLogout(navigate);
        }
    })

};

export const remember = (data) => {
    return middlewareEncryption("/api/users/rememberMe", data)
};
export const rememberPassword = () => {

    const token = JSON.parse(localStorage.getItem("user"));
    const browser_id = localStorage.getItem("browserId");
    let data = {
        "email": token.email,
        "browser_id": browser_id
    }
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/users/RememberedLogin`, DataEncription(data))
};

export const clearRememberMe = () => {
    const token = JSON.parse(localStorage.getItem("user"));
    const browser_id = localStorage.getItem("browserId");
    let data = {
        "email": token.email,
        "browser_id": browser_id
    }
    return middlewareEncryption("/api/users/clearRememberedLogin", data)
};

export const creatNewUser = (data) => {
    return middlewareEncryption("/api/admin/createUser", data)
};
export const getAllUser = (page, rowsPerPage, searchText, columnFilters, sorting, dataType) => {
    
    const filterNew  = JSON.stringify(columnFilters ?? []);
    const sortingConv  = JSON.stringify(sorting ?? []);
    if(page == undefined || rowsPerPage == undefined){
        return middlewareDecryption(`/api/admin/getAlluser`)
    }
    return middlewareDecryption(`/api/admin/getAlluser?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filterList=${filterNew}&sort=${sortingConv}&dataType=${dataType}`)
};
export const getUsersDetailsByRole = (page, rowsPerPage, searchText, columnFilters, sorting) => {    
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    if(!role_id){
        return toast.error('Role missing in route');
    }
    // if(page == undefined || rowsPerPage == undefined){
    //     return middlewareEncryption(`/api/dealership/getUsersDetailsByRole/${role_id}`, {data})
    // }
    const queryParameters = new URLSearchParams(window.location.search)
    // const type = queryParameters.get("type")
    // const name = queryParameters.get("name")

    
    // flag for user list 
    // admin - 1, ccm-2, 3-dm, dsp

    // if(role_id = 9){}
    let dataType = 1;

    // Get the current URL from the browser
    const currentURL = window.location.href;

    // Check if the URL contains '/dealership/users' or '/dealership/company' and set dataType accordingly
    if (currentURL.includes('/affiliations/dealerships/users')) {
        dataType = 3;
    } else if (currentURL.includes('/affiliations/companies/users')) {
        dataType = 2;
    }
   

    const data = createFilterData(columnFilters, page, rowsPerPage);

    data.adminFLAG = dataType;

    return middlewareEncryption(`/api/dealership/getUsersDetailsByRole/${role_id}`, data)
};
export const getUserbyId = (id) => {
    return middlewareDecryption(`/api/admin/getuserById/${id}`);

};
export const editUser = (id, data) => {
    return middlewareEncryption(`/api/admin/editUser/${id}`, data)
};

export const getAllLower = (id) => {
    return middlewareDecryption(`/api/users/getAllLower/${id}`);
};

export const changeStatus = (id, data) => {
    return middlewareEncryption(`/api/admin/changeStatus/${id}`, data)
};

//Role API
export const creatNewRole = (data) => {
    return middlewareEncryption("/api/admin/createRole", data)
};

export const getAllRole = (type = "API") => {
    return middlewareDecryption(`/api/admin/getAllRole`, type);
};

export const getRoleById = (id) => {
    return middlewareDecryption(`/api/admin/getRoleById/${id}`);

};
export const editRole = (id, data) => {
    return middlewareEncryption(`/api/admin/updateRole/${id}`, data)
};

export const activteRoles = (id, data) => {
    return middlewareEncryption(`/api/admin/activateRole/${id}`, data)

};

export const deleteRoles = (id, data) => {
    return middlewareEncryption(`/api/admin/deleteRole/${id}`, data)
};

//permission
export const creatNewPermission = (data) => {
    return middlewareEncryption("/api/admin/createPermission", data)
};

export const getAllPermission = () => {
    return middlewareDecryption(`/api/admin/getAllPermission`);
};

export const getPermissionsById = (id) => {
    return middlewareDecryption(`/api/admin/getPermissionById/${id}`);
};

export const editPermission = (id, data) => {
    return middlewareEncryption(`/api/admin/updatePermission/${id}`, data)
};

export const deletePermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/deletePermission/${id}`, data)
};

export const activatePermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/activatePermission/${id}`, data)
};
export const deactivatePermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/deactivatePermission/${id}`, data)
};

//RoleHasPermissions
export const creatNewroleHaspermissions = (data) => {
    return middlewareEncryption("/api/admin/createRoleHasPermission", data)
};

export const getAllRoleHasPermission = () => {
    return middlewareDecryption(`/api/admin/getAllRoleHasPermission`);
};

export const getRoleHasPermissionById = (id) => {
    return middlewareDecryption(`/api/admin/getRoleHasPermissionById/${id}`);
};

export const editRoleHasPermission = (id, data) => {
    return middlewareEncryption(`/api/admin/updateRoleHasPermission/${id}`, data)
};

export const deleteRoleHasPermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/deleteRoleHasPermission/${id}`, data)
};

export const activateRoleHasPermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/activateRoleHasPermission/${id}`, data)
};

//UserHasRole
export const creatNewUserHasRole = (data) => {
    return middlewareEncryption("/api/admin/createuserHasRole", data)
};

export const getUserHasRoleById = (id) => {
    return middlewareDecryption(`/api/admin/getuserHasRoleById/${id}`);
};

export const UpdateUserHasRole = (id, data) => {
    return middlewareEncryption(`/api/admin/updateUserHasRole/${id}`, data)
};

export const deleteUserHasRole = (id, data) => {
    return middlewareEncryption(`/api/admin/deleteuserHasRole/${id}`, data)
};
export const activateUserHasRole = (id) => {
    return middlewareDecryption(`/api/admin/activateuserHasRole/${id}`);
};

//logs



export const getAllError = (page) => {
    return middlewareDecryption(`/api/admin/getAllActivity?type=error&pageNo=${page}`);
};
export const getAllActivity = (page) => {

    return middlewareDecryption(`/api/admin/getAllActivity?type=activity&pageNo=${page}`);
};
export const getAllPolicyElastic = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    let data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/admin/getAllPolicyElastic`, data);
};
export const getAllActivityCron = (id) => {
    return middlewareDecryption(`/api/admin/getAllActivity?type=cron&pageNo=${id}`);
};
export const getAllApi = (id) => {
    return middlewareDecryption(`/api/admin/getAllActivity?type=api&pageNo=${id}`);
};
//sales
export const creatNewCategory = (data) => {
    return middlewareEncryption("/api/sales/addCategory", data)
};

export const getAllCategories = () => {
    return middlewareDecryption(`/api/sales/getAllCategory`);
};

// Active Categories only
export const getAllCategory = () => {
    return middlewareDecryption(`/api/sales/getActiveCategory`);
};

export const getCategoryById = (id) => {
    return middlewareDecryption(`/api/sales/getCategoryById/${id}`);
};

export const getCategoryByBrandId = (id) => {
    return middlewareDecryption(`/api/affiliation/getcategoryByBrandID/${id}`);
};
export const getProductBySaleDateAndCategory = (data) => {
    return middlewareEncryption(`/api/product/getProductToSale`,data);
};
export const getProductDetails = (data) => {
    return middlewareEncryption(`/api/product/getProductTax`,data);
};

export const editCategory = (id, data) => {
    return middlewareEncryption(`/api/sales/updateCategory/${id}`, data)
};
export const deleteCategories = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/sales/deleteCategory/${id}`, { headers });
};
export const activateCategory = (id) => {
    return middlewareDecryption(`/api/sales/activateCategory/${id}`)
};
export const getCompanyByCategoryId = (id) => {
    return middlewareDecryption(`/api/sales/getCompanyByCategoryId/${id}`)
};

//Service
export const creatNewService = (data) => {
    return middlewareEncryption("/api/sales/addService", data)
};

// export const getAllService = (page, rowsPerPage, searchText, filterList, sortOrder) => {
//     return middlewareDecryption(`/api/sales/getAllService?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterList}&sort=${sortOrder}`);

// };

export const getAllService = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const filterNew  = JSON.stringify(columnFilters ?? []);
    const sortingConv  = JSON.stringify(sorting ?? []);
    if(page == undefined || rowsPerPage == undefined){
        return middlewareDecryption(`/api/sales/getAllService`)
    }
    return middlewareDecryption(`/api/sales/getAllService?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText || ""}&filter=${filterNew}&sort=${sortingConv}`)
};
export const deleteServices = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/sales/deleteService/${id}`, { headers });
};

export const getServiceById = (id) => {
    return middlewareDecryption(`/api/sales/getServiceById/${id}`);
};

export const editServices = (id, data) => {
    return middlewareEncryption(`/api/sales/updateService/${id}`, data)
};

export const activateService = (id) => {
    return middlewareDecryption(`/api/sales/activateService/${id}`);
};  

//Taxes
export const creatNewTax = (data) => {
    return middlewareEncryption("/api/sales/addTax", data)
};

export const getAllParentTax = () => {
    return middlewareDecryption(`/api/sales/getAllTax`);
};

export const getTaxById = (id) => {
    return middlewareDecryption(`/api/sales/getTaxById/${id}`);
};

export const activateParentTax = (id) => {
    return middlewareDecryption(`/api/sales/activateTax/${id}`);
};

export const updateParentTax = (id, data) => {
    return middlewareEncryption(`/api/sales/updateTax/${id}`, data)
};

// coupons

export const creatNewCoupon = (data) => {
    return middlewareEncryption("/api/sales/addCoupon", data)
};

export const getAllCoupons = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    // return middlewareDecryption(`/api/sales/getAllCoupon`);
    const filterNew  = JSON.stringify(columnFilters ?? []);
    const sortingConv  = JSON.stringify(sorting ?? []);
    if(page == undefined || rowsPerPage == undefined){
        return middlewareDecryption(`/api/sales/getAllCoupon`)
    }
    return middlewareDecryption(`/api/sales/getAllCoupon?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
};

export const getCouponById = (id) => {
    return middlewareDecryption(`/api/sales/getCouponById/${id}`);
};

export const editCoupon = (id, data) => {
    return middlewareEncryption(`/api/sales/updateCoupon/${id}`, data)
};


export const deleteCoupon = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/sales/deleteCoupon/${id}`, { headers });
};

export const activateCoupon = (id) => {
    return middlewareDecryption(`/api/sales/activateCoupon/${id}`);
};
//Brand 
export const getAllBrand = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllBrand`, data)
};
export const getActiveBrand = () => {
    return middlewareDecryption(`/api/affiliation/getBrandList`)
};
export const creatNewBrand = (data) => {
    return middlewareEncryption("/api/affiliation/addBrand", data)
};
export const getBrandById = (id) => {
    return middlewareDecryption(`/api/affiliation/getBrandById/${id}`);
};

export const editBrand = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateBrand/${id}`, data)
};

export const deleteBrand = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteBrand/${id}`, { headers });
};

export const activateBrand = (id,) => {

    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateBrand/${id}`, {}, { headers });
};
//fuel


export const creatNewFuel = (data) => {
    return middlewareEncryption("/api/affiliation/addFuel", data)
};

// export const getAllFuel = (page, rowsPerPage, searchText, columnFilters, sorting) => {

//     if(!page || !rowsPerPage){
//         return middlewareDecryption(`/api/affiliation/getAllFuel`)
//     }

//     const filterNew  = JSON.stringify(columnFilters ?? []);
//     const sortingConv  = JSON.stringify(sorting ?? []);
//     if(page == undefined || rowsPerPage == undefined){
//         return middlewareDecryption(`/api/affiliation/getAllFuel`)
//     }
//     return middlewareDecryption(`/api/affiliation/getAllFuel?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
// };

export const getAllFuel = (page, rowsPerPage, searchText, columnFilters, sorting) => {
   
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllFuel`, data)
};

export const getFuelById = (id) => {
    return middlewareDecryption(`/api/affiliation/getFuelById/${id}`);
};
export const getFuelByBrandId = (id) => {
    return middlewareDecryption(`/api/affiliation/getFuelByBrandId/${id}`);
};

export const editFuel = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateFuel/${id}`, data)
};
export const deleteFuels = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteFuel/${id}`, { headers });
};
export const activateFuel = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateFuel/${id}`, {}, { headers });
};

//Transmission
export const creatNewTransmission = (data) => {
    return middlewareEncryption(`/api/affiliation/addTransmission`, data)
};

// export const getAllTransmissin = (page, rowsPerPage, searchText, columnFilters, sorting) => {
//     // return middlewareDecryption(`/api/affiliation/getAllTransmission`);
//     const filterNew  = JSON.stringify(columnFilters ?? []);
//     const sortingConv  = JSON.stringify(sorting ?? []);
//     if(page == undefined || rowsPerPage == undefined){
//         return middlewareDecryption(`/api/affiliation/getAllTransmission`)
//     }
//     return middlewareDecryption(`/api/affiliation/getAllTransmission?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
// };

export const getAllTransmissin = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllTransmission`, data)
};

export const getTransmissionById = (id) => {
    return middlewareDecryption(`/api/affiliation/getTransmissionById/${id}`);
};
export const getTransmissionByBrandId = (id) => {
    return middlewareDecryption(`/api/affiliation/getTransmissionByBrandId/${id}`);
};

export const ediTransmissoin = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateTransmission/${id}`, data)
};
export const deleteTransmission = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteTransmission/${id}`, { headers });
};
export const activateTransmission = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateTransmission/${id}`, {}, { headers });
};

//Model
export const creatNewModel = (data) => {
    return middlewareEncryption(`/api/affiliation/addModel`, data)
};

export const getAllModel = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    
    return middlewareEncryption(`/api/affiliation/getAllModel`, data)
};

export const getModelById = (id) => {
    return middlewareDecryption(`/api/affiliation/getModelById/${id}`);
};
export const getModelsByBrandById = (id) => {
    return middlewareDecryption(`/api/affiliation/getModelByBrandId/${id}`);
};

export const updateModel = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateModel/${id}`, data);
};
export const deleteModelS = (id) => {
    const token = localStorage.getItem("token");
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteModel/${id}`, { headers });
};
export const activateModel = (id) => {
    const token = localStorage.getItem("token");
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateModel/${id}`, {}, { headers });
};
//---Configuration---
//for create new configuration by add new Modal
export const createNewConfiguration=(data)=>{
    return middlewareEncryption('/api/admin/addGlobalConfiguration', data)
};

export const activateConfiguration = (id) => {
    const token = localStorage.getItem("token");
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/ api`, {}, { headers });
};

//for 'submit' in edit modal and updating 'status'
export const updateConfiguration = (id, data) => {
    return middlewareEncryption(`/api/admin/updateGlobalConfiguration/${id}`, data);
};

//for get data in edit modal
export const getConfigurationById = (id) => {
    return middlewareDecryption(`/api/admin/getGlobalConfigurationById/${id}`);
};
//for pagination
export const getAllConfiguration = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/admin/getAllGlobalConfiguration`, data)
};


//Variant
export const createNewVariant = (data) => {
    return middlewareEncryption(`/api/affiliation/addVariant`, data);
};

export const getAllVariant = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllVariant`, data)
    
};

export const getVariantById = (id) => {
    return middlewareDecryption(`/api/affiliation/getVariantById/${id}`);
};
export const getVariantByModelId = (id) => {
    return middlewareDecryption(`/api/affiliation/getVariantByModelId/${id}`);
};

export const updateVariant = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateVariant/${id}`, data);
};
export const deleteVariants = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteVariant/${id}`, { headers });
};
export const activateVariant = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateVariant/${id}`, {}, { headers });
};
//client company
export const createNewCompany = (data) => {
    return middlewareEncryption("/api/affiliation/addCompany", data)
};

export const getAllCompanys1 = () => {
    return middlewareDecryption(`/api/affiliation/getAllCompany`);
};
export const getAllCompanys = () => {    
    return middlewareDecryption(`/api/affiliation/getAllCompany`)
};
export const getActiveCompany = () => {    
    return middlewareDecryption(`/api/affiliation/getActiveCompany`)
};
export const getCompanyData = () => {    
    return middlewareDecryption(`/api/affiliation/getCompanyData`)
};
export const getDealerData = () => {    
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    return middlewareDecryption(`/api/affiliation/getDealerData/${role_id}`)
};
export const getUserData = () => {    
    return middlewareDecryption(`/api/dealership/getUserData`)
};
export const getTotalDealers2 = () => {    
    return middlewareDecryption(`/api/affiliation/getTotalDealers`)
};

export const getAllCompanyList = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    
    // const filterNew  = JSON.stringify(columnFilters ?? []);
    // const sortingConv  = JSON.stringify(sorting ?? []);
    // if(page == undefined || rowsPerPage == undefined){
    //     return middlewareDecryption(`/api/affiliation/getAllCompanyList`)
    // }
    // return middlewareDecryption(`/api/affiliation/getAllCompanyList?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filterList=${filterNew}&sort=${sortingConv}`)
    let data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllCompanyList`, data)


};

export const getCompanyById = (id) => {
    return middlewareDecryption(`/api/affiliation/getCompanyById/${id}`);
};

export const getbrandbycompanyid = (id) => {
    return middlewareDecryption(`/api/affiliation/getbrandbycompanyid/${id}`);
};

export const getClientConfigCompanyById = (id) => {
    return middlewareDecryption(`/api/sales/getClientConfigCompanyById/${id}`);
};

export const getcategoryBrandBycompanyId = (id) => {
    return middlewareDecryption(`/api/sales/getcategoryBrandBycompanyId/${id}`);
};

export const updateCompany = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateCompany/${id}`, data)
};

export const deleteCompany = (id) => {

    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteCompany/${id}`, { headers });
};

export const activateCompany = (id) => {
    // return middlewareDecryption(`/api/affiliation/activateCompany/${id}`);
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateCompany/${id}`, {}, { headers });
};

//client Dealer
export const createNewDealer = (data) => {
    return middlewareEncryption("/api/affiliation/addDealership", data)
};
export const bulkUploadDealer = (data) => {
    return middlewareEncryption("/api/affiliation/dealershipBulkUpload", data)
};

export const getAllDealers = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    
    let data = createFilterData(columnFilters, page, rowsPerPage);

    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    
    return middlewareEncryption(`/api/affiliation/getDealershipBynew/`+ role_id, data);
};
export const getDealerById = (id) => {
    return middlewareDecryption(`/api/affiliation/getDealershipById/${id}`);
};

export const updateDealer = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateDealership/${id}`, data)
};

export const deleteDealer = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteDealership/${id}`, { headers });
};

export const activateDealer = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateDealership/${id}`, {}, { headers });
};

//Company user

export const createNewCompanyUser = (data) => {
    return middlewareEncryption(`/api/affiliation/addCompanyUser`, data)
};

//Dealership user
export const createNewDealershipUser = (data) => {
    return middlewareEncryption(`/api/affiliation/addDealershipUser`, data)
};
export const getDealerByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/getDealershipByCompanyId/${id}`);
};



//Product
export const createNewProduct = (data) => {
    return middlewareEncryption("/api/product/addProduct", data)
};

export const getAllProducts = () => {
    return middlewareDecryption(`/api/product/getAllProducts`);
};

export const getProductById = (id) => {
    return middlewareDecryption(`/api/product/getProductById/${id}`);
};

// export const getProductClientByClientId = (id) => {
//     return middlewareDecryption(`/api/product/getProductClientByClientId/${id}`);
// };

export const updateProduct = (id, data) => {
    return middlewareEncryption(`/api/product/updateProduct/${id}`, data)
};

export const deleteProduct = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/product/deleteProduct/${id}`, { headers });
};

export const activateProduct = (id) => {
    // const token = localStorage.getItem("token")
    // const headers = {
    //     'Authorization': token
    // };
    // return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/product/activateProduct/${id}`, {}, { headers });
    return middlewareEncryption(`/api/product/activateProduct/${id}`);
};


//wallet
export const getAllAdminWallet = (id) => {
    return middlewareDecryption(`/api/navision/getAllAdminWallet`);
};
export const getAllDealerWalletClosureInitiated = () => {
    return middlewareDecryption(`/api/dealership/listAllDealerWalletClosureInitiated`);
};

export const listAllDealerWalletStatus = () => {
    return middlewareDecryption(`/api/dealership/listAllDealerWalletStatus`);
};

export const getAllWalletRefund = (id) => {
    return middlewareDecryption(`/api/navision/getAllWalletRefund`);
};
export const getWalletBalance = (data) => {
    return middlewareEncryption(`/api/dealership/getWalletbalance`, data);
};

export const getWalleTransactions = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    
    const user = JSON.parse(localStorage.getItem("user"));
    const id = user?.dealerInfo?.dealership_id  ? user.dealerInfo?.dealership_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getWalletHistoryByDealerId/${id}`, data);

};


// export const getAllAdminWalletHistory = (data) => {
//     return middlewareEncryption(`/api/dealership/getAllAdminHistory`, data);
// };

export const getAllAdminWalletHistory = (data, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const reqData = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getAllAdminHistory`, { ...data, ...reqData })
};

export const getAllAdminHistoryOnlyCredit = (data, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const reqData = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getAllAdminHistoryOnlyCredit`, { ...data, ...reqData });
};

export const walletClosureRequest = (id, data) => {
    return middlewareEncryption(`/api/dealership/initiateDealerWalletClosure/${id}`, data);
};
export const closeDealerWallet = (id, data) => {
    return middlewareEncryption(`/api/dealership/closeDealerWallet/${id}`, data);
};


//MY UserHasRole
export const getMyuserHasRole = () => {
    return middlewareDecryption(`/api/users/getMyuserHasRole`);
};


export const getAllCountry = () => {
    return middlewareDecryption(`/api/users/getAllCountry`)
}
export const getAllState = (id) => {
    return middlewareDecryption(`/api/users/getAllStateBYCountryId/${id}`)
}
export const getAllCity = (id) => {
    return middlewareDecryption(`/api/users/getAllcityByStateId/${id}`)
}


//report
export const CreateNewMisReport = (data) => {
    return middlewareEncryption(`/api/sales/getMisReport`, data);
};

//Add help desk
export const createNewHelDesk = (data) => {
    return middlewareEncryption("/api/users/addHelpDeskDocument", data)
};

export const updateHelpdesk = (id, data) => {
    return middlewareEncryption(`/api/users/editHelpDeskDocument/${id}`, data)
};


export const getAllHelpDeskFile = () => {
    return middlewareDecryption(`/api/users/getHelpDeskDocument`);
};

export const getAllActivityByRange = (data) => {
    return middlewareEncryption(`/api/admin/getAllActivityByRange`, data);
};




//


export const getProductClientByClientId = (id) => {
    return middlewareDecryption(`/api/product/getProductClientByClientIdNew/${id}`);
};

export const getAllProductClientByDealershipId = (id) => {
    return middlewareDecryption(`/api/product/getAllProductClientByDealershipId/${id}`);
};


export const assignProductClient = (data) => {
    return middlewareEncryption(`/api/product/assignProductClient`, data);
};

export const assignProductDealership = (data) => {
    return middlewareEncryption(`/api/product/assignProductDealership`, data);
};

export const getAllProductClient = (id) => {
    return middlewareDecryption(`/api/product/getAllProductClient`);
};

export const assignProductClientModelVariant = (data) => {
    return middlewareEncryption(`/api/product/assignProductClientModelVarient`, data);
};

export const assignProductClientModel = (data) => {
    return middlewareEncryption(`/api/product/assignProductClientModel`, data);
};

export const getModelByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/getModelByCompanyId/${id}`);
};

// export const getVariantByModelId = (id) => {
//     return middlewareDecryption(`/api/affiliation/getVariantByModelId/${id}`);
// };

// Sachin's Route
export const createNewUser = (data) => {
    return middlewareEncryption("/api/admin/createUser", data)
};

export const getPincodeDetails = (id, data) => {
    return middlewareDecryption(`/api/admin/getPincodeDetails/${id}`, data)
};

export const updateRoleOrder = () => {
    return 'success';
};

export const getServiceByCategoryId = (id) => {
    return middlewareDecryption(`/api/sales/getServiceByCategoryId/${id}`)
};

export const getAllProductList = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const filterNew  = JSON.stringify(columnFilters ?? []);
    const sortString  = JSON.stringify(sorting ?? []);
    const data = createFilterData(columnFilters, page, rowsPerPage);
  
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    // return middlewareDecryption(`/api/product/getAllProductList?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortString}`)
    return middlewareEncryption(`/api/product/getAllProductList/`+role_id, data)
};

export const getAllProductClientModel = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/product/getAllProductClientModel`, data);
};

export const editHelpDeskDocument = (id, data) => {
    return middlewareEncryption(`/api/users/editHelpDeskDocument/${id}`, data)
};
export const getHelpDeskDocumentByDealerId = (id) => {
    return middlewareDecryption(`/api/users/getHelpDeskDocumentByDealerId/${id}`)
};

export const getDealerLatestInvoiceNumber = (id) => {
    return middlewareEncryption(`/api/dealership/getDealerFinalInvoiceNumber/${id}`)
};

export const saveDealerCommissionInvoice = (data) => {
    return middlewareEncryption("/api/dealership/saveDealerCommissionInvoice", data)
};

export const getHelpDeskDocumentByCompanyRoleId = (id, secondId) => {
    return middlewareDecryption(`/api/users/getHelpDeskDocumentByCompanyRoleId/${id}/${secondId}`)
};


export const getAllPolicy = (page=0, rowsPerPage=10, searchText="", columnFilters=[], sorting=[]) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';

    // if(ROLE.key == 'DEALERSHIP_MANAGER' || ROLE.key == 'DEALER_SALES_PERSON'){
    //     return middlewareDecryption(`/api/dealership/getPolicyDetailsByDealer/`+user?.dealerInfo?.dealership_id);
    // }
    //  Aa of now we will keep it, we want all data in one api only, handle in backend by session

    // return middlewareDecryption(`/api/dealership/getPolicyDetailsByRole/`+ role_id +'?pageNo='+page+'&pageSize='+rowsPerPage);
    
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getPolicyDetailsByRole/`+ role_id, data);

};

export const getAllPolicy2 = (page=0, rowsPerPage=10, searchText="", columnFilters=[], sorting=[]) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getPolicyDetailsByRoleAssociated/`+ role_id, data);

};

export const getPolicyDetailsByDealer  = () => {
    return middlewareDecryption(`/api/dealership/getPolicyDetailsByDealer `);
};

export const getPolicyDetailsById = (id) => {
    return middlewareDecryption(`/api/dealership/getPolicyDetails/${id}`)
};

export const bulkUploadPolicyInitiate = (data) => {
    return middlewareEncryption("/api/dealership/bulkUploadPolicyInitiate", data)
};
export const bulkUploadPolicy = (data) => {
    return middlewareEncryption("/api/dealership/saveBulkPolicy", data)
};

// export const addDMSDataByUrl = (data) => {
//     return middlewareEncryption("/api/affiliation/addDmsDataByURL", data,true,true)
// };
export const DMSDataCsvUpload = (data) => {
    return middlewareEncryption("/api/affiliation/addDmsDataByURL", data)
};

export const festiveDataUpload = (data) => {
    return middlewareEncryption("/api/affiliation/festiveDataUpload", data)
};

//session

// Festive Greeting Mail Trigger
export const festiveDataMailTrigger = (data) => {
    return middlewareEncryption("/api/affiliation/festiveDataMailTrigger", data)
};

export const getAllSessions = () => {
    return middlewareDecryption(`/api/users/getAllSessions`);
};

// export const deleteSessions = (id) => {
//     return middlewareEncryption(`/api/users/deleteSessions/${id}`)
// };

// export const deleteSessions = (data) => {
//     return middlewareEncryption("/api/users/deleteSessions", data)
// };

export const deleteSessions = (id) => {
    const data = {
        'id': id,
        "yek_ku76H6felco7" : "#$x82kc6&m*E"
    };
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/users/deleteSessions`, data);
}

//Dms Data
export const creatNewDms_data = (data) => {
    return middlewareEncryption("/api/affiliation/addDms_data", data)
};

export const getAllDms_data = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    // return middlewareDecryption(`/api/affiliation/getAllDms_data`);
    const filterNew  = JSON.stringify(columnFilters ?? []);
    const sortingConv  = JSON.stringify(sorting ?? []);
    if(page == undefined || rowsPerPage == undefined){
        return middlewareDecryption(`/api/affiliation/getAllDms_data`)
    }
    return middlewareDecryption(`/api/affiliation/getAllDms_data?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
};

export const getDms_dataById = (id) => {
    return middlewareDecryption(`/api/affiliation/getDms_dataById/${id}`);
};

export const editDms_data = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateDms_data/${id}`, data)
};
export const deleteDms_data = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteDms_data/${id}`, { headers });
};
export const activateDms_data = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateDms_data/${id}`, {}, { headers });

};

// Get all dms upload data list 
export const getDmsDataHistory = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getDmsDataHistory`, data);
};

// Get all the festive greetings imagUrl and emailBody
export const getFestiveDataHistory = async () => {
    try {
        return middlewareDecryption(`/api/affiliation/getFestiveDataHistory`);
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};

// Get all the global configuration data
export const getGlobalConfigDataFetch = async () => {
    try {
        return middlewareDecryption(`/api/admin/getAllGlobalConfiguration`);
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};

// DMS list
export const getAllDmsData = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllDmsData`, data);
};

export const getDmsDataById = (id) => {
    return middlewareDecryption(`/api/affiliation/getDmsDataById/${id}`);
};


// Dashboard APIs
export const getGrandTotal = () => {
    // return middlewareDecryption(`/api/dealership/getGrandTotal`);
    return {};
    // return middlewareDecryption(`/api/dealership/getThisMonthDashBoard`);

};

export const getPolicyStatus = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    // return middlewareEncryption(`/api/dealership/getdealerPolicyStatus/`+ role_id,{timeInterval:data});
    return {};
};

export const getPolicySales = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getdealerPolicySales`,{role: key, timeInterval:data});
};

export const getClientWiseSales = (clientWiseSales, companyId) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getPolicySalesByClient`,{role: key, timeInterval:clientWiseSales, company_id: companyId});
};

export const getMyRequestData = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getMyRequestByTimeInterval`,{role: key, timeInterval:data});
};

export const getDspPerformanceData = (dealership_id) => {
    return middlewareEncryption(`/api/dealership/getDspPerformanceWithPolicySales`,{dealership_id: dealership_id});
};

export const getTotalSystemUsers = () => {
    return middlewareDecryption(`/api/dealership/getTotalSystemUsers`);
};

export const getTotalDealers = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getTotalDealers`,{role: key});
};

export const editPolicyDetails = (id, data) => {
    return middlewareEncryption(`/api/dealership/editPolicyDetails/${id}`, data);
};
export const forcePolicyEdit = (id, data) => {
    return middlewareEncryption(`/api/admin/forcePolicyEdit/${id}`, data);
};

export const getDealerRanking = (dealership_id) => {
    // return middlewareDecryption(`/api/dealership/getDealerRanking/`+ dealership_id);
    return {};

};

export const getPolicyExpirationData = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getPolicyExpirationCount`, {role: key, timeInterval:data});
};

export const getAllDealerKycStatus = () => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareDecryption(`/api/dealership/getAlldealerKycStatus`,{role: key});
};

export const submitKyc = (data) => {
    return middlewareEncryption("/api/dealership/submitKyc", data)
};

export const getKycDetailsByDealerId = (id) => {
    return middlewareDecryption(`/api/dealership/getKycDetailsByDealerId/${id}`);
};
// export const getDealerGrandTotal = () => {
//     return middlewareDecryption(`/api/dealership/getdealerTotal`);
// };

export const getDealerGrandTotal = (id) => {
    return middlewareDecryption(`/api/dealership/getdealerTotal/${id}`);
};


// Product list by client id
export const getProductByClientId = (id) => {
    return middlewareDecryption(`/api/product/getProductByClientId/${id}`);
};


export const getDealersTransactionByDate = (data) => {
    return middlewareEncryption("/api/admin/walletTransactionsByDate", data)
}

export const stateCityByPincode = (id) => {
    return middlewareDecryption(`/api/users/getDataByPincode/${id}`)
};

// Client configuration update or add
export const addOrUpdateClientConfiguration = (data) => {
    return middlewareEncryption(`/api/affiliation/addOrUpdateClientConfiguration`, data)
};
export const clientCompanyWithConfigurationByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/clientCompanyWithConfigurationByCompanyId/${id}`)
};

//training
//training-module
export const createTrainingModule = (data) => {
    return middlewareEncryption(`/api/training/createTraining`, data)
};

export const getAllTrainingModule = () => {
    return middlewareDecryption(`/api/training/getAllTrainingModule`);
};

export const getTrainingModuleByClientId = (id) => {
    return middlewareDecryption(`/api/training/getTrainingModuleByClientId/${id}`)
};
//ui pending from om
export const updateTrainingModule = (id, data) => {
    return middlewareEncryption(`/api/training/updateTrainingModule/${id}`, data)
};


//training-topic
export const addTopicByModuleId = (moduleId, data) => {
    return middlewareEncryption(`/api/training/addTopic/${moduleId}`, data)
};

export const getAllTrainingTopic = () => {
    return middlewareDecryption(`/api/training/getAllTrainingTopic`);
};

export const getTopicByModuleId = (id) => {
    return middlewareDecryption(`/api/training/getTopicByModuleId/${id}`)
};
export const updateTrainingTopic = (id, data) => {
    return middlewareEncryption(`/api/training/updateTrainingTopic/${id}`, data)
};


//training quiz

export const createTrainingQuiz = (data) => {
    return middlewareEncryption(`/api/training/createTrainingQuiz`, data)
};
export const getQuizByTopicId = (id, data) => {
    return middlewareEncryption(`/api/training/getQuizByTopicId/${id}`, data)
};

export const trainingQuizTest = (data) => {
    return middlewareEncryption(`/api/training/trainingQuizTest`, data)
};
export const trainingQuizResult = (data) => {
    return middlewareEncryption(`/api/training/trainingQuizResult`, data)
};

export const getAllQuiz = () => {
    return middlewareDecryption(`/api/training/getAllQuiz`);
};

export const updateTrainingQuiz = (id, data) => {
    return middlewareEncryption(`/api/training/updateTrainingQuiz/${id}`, data)
};

export const getQuizUserAnswersByTopicId = (id, data) => {
    return middlewareEncryption(`/api/training/getQuizUserAnswersByTopicId/${id}`, data)
};

// Ticketing system
// export const getTickets = (data) => {
//     return middlewareEncryption(`/api/dealership/getTickets/`, data)
// };
export const getTickets = (payload, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/dealership/getTickets/`, combinedData)
};

export const getTicketHistory = (id) => {
    return middlewareDecryption(`/api/dealership/getTicketHistory/${id}`,)
};
export const getTicketHistoryByUserId = () => {
    return middlewareDecryption(`/api/dealership/getticketHistoryByUserId/`,)
};
// export const getTicketsByMe = () => {
//     return middlewareDecryption(`/api/dealership/getticketsByMe/`,)
// };
export const getTicketsByMe = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';

    const data = createFilterData(columnFilters, page, rowsPerPage, role_id);
    return middlewareEncryption(`/api/dealership/getticketsByMe`, data)
};
// export const getAllTickets = ( page, rowsPerPage, searchText, columnFilters, sorting, role) => {

//     const ROLE = JSON.parse(localStorage.getItem("ROLE"));
//     const roleId = ROLE?.role_id ? ROLE.role_id : '';
//     const data = createFilterData(columnFilters, page, rowsPerPage, roleId);
//     console.log(data,"--------data");

//     return middlewareEncryption(`/api/dealership/getAllTickets/`, data)
// };

export const getAllTickets = (page, rowsPerPage, searchText, columnFilters, sorting,roleId) => {
    const payload = {
        // is_active: true,
        roleId : roleId
    };
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data };
    return middlewareEncryption("/api/dealership/getAllTickets", combinedData)
};
// export const getAllActionTicketsByMe = (data) => {
//     return middlewareEncryption(`/api/dealership/getMyActionTickets`, data)
// };
export const getAllActionTicketsByMe = (payload,page,rowsPerPage,searchText,columnFilters,sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/dealership/getMyActionTickets`, combinedData)
};
export const requestCancelPolicy = (id, data) => {
    return middlewareEncryption(`/api/dealership/requestCancelPolicy/${id}`, data)
};
export const requestWalletClosure = (id, data) => {
    return middlewareEncryption(`/api/dealership/initiateDealerWalletClosureTicketing/${id}`, data)
};

export const forcePolicyCancellation = (data) => {
    return middlewareEncryption(`/api/admin/forcePolicyCancellation`, data)
};

export const acceptOrRejectTicket = (data) => {
    return middlewareEncryption(`/api/dealership/acceptOrRejectTicket`, data)
};

export const deleteProductClientByClientId_ = (data) => {
    return middlewareEncryption(`/api/product/deleteProductClientByClientId_`, data)
};

export const deleteProductClientByDealershipId = (data) => {
    return middlewareEncryption(`/api/product/deleteProductClientByDealershipId`, data)
};

export const getMisReportByRange = (data) => {
    return middlewareEncryption(`/api/sales/getMisReportByRange`, data)
}

export const getMisReportByCompanyId = (data) => {
    return middlewareEncryption(`/api/sales/getMisReportByCompanyId`, data)
}
export const getAllCompanyMisReport = () => {
    return middlewareDecryption(`/api/sales/getAllCompanyMisReport`)
}
export const adminToWalletTransfer = (id, data) => {
    return middlewareEncryption(`/api/dealership/transferFromAdminTowallet/${id}`, data)
};

export const getDealershipByIdWithWalletInfo = (id) => {
    return middlewareDecryption(`/api/affiliation/getDealershipByIdWithWalletInfo/${id}`);
}
export const getAllProductClientModelVarient = (client_id) => {
    return middlewareDecryption(`/api/product/getAllProductClientModelVarient/`+client_id+`?sales_category_id=1`);
}
export const validatePanCard = (data) => {
    return middlewareEncryption(`/api/dealership/validatePanCard/`, data);
}
export const validateGstnNumber = (data) => {
    return middlewareEncryption(`/api/dealership/validateGSTIN/`, data);
}
export const transferFromDealerToAdminWallet = (wallet_id, data) => {
    return middlewareEncryption(`/api/dealership/transferFromDealerToAdminWallet/`+ wallet_id, data);
}

export const communicationHealth = () => {
    return middlewareDecryption(`/api/users/communicationHealth/`);
}
export const runCommunicationScript = () => {
    return middlewareEncryption(`/api/users/add-bulk-templates/`);
}
export const addProductSchedule = (data) => {
    return middlewareEncryption(`/api/product/addProductSchedule`, data)
};
export const getProductSchedule = (id) => {
    return middlewareDecryption(`/api/product/getProductSchedule/${id}`,)
};
export const getAllRefundTxnHistory = () => {
    return middlewareDecryption(`/api/dealership/getAllRefundTxnHistory`);
};
export const getCustomerDetails = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getCustomerDetails`, data);
};
export const getCompanyByCategories = (data) => {
    return middlewareDecryption(`/api/sales/getCompanyByCategories`,data)
};
export const deleteProductSchedule = (data) => {
    return middlewareEncryption(`/api/product/deleteProductSchedule`,data)
};
export const deleteMultipleSessions = (data) => {
    return middlewareEncryption(`/api/users/deleteMultipleSessions`,data)
};

export const addVisitingReport = (data) => {
    return middlewareEncryption("/api/affiliation/addVisitingReport", data)
};

export const getAllVisitingReport = () => {
    return middlewareDecryption(`/api/affiliation/getAllVisitingReport`);
};

export const updateVisitingReport = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateVisitingReport/${id}`, data)
};

export const getYtdPolicyCount = () => {
    return middlewareDecryption(`/api/sales/getYtdPolicyCount`);
};
export const getMtdDealersPolicyCount = () => {
    // return middlewareDecryption(`/api/sales/getMtdDealersPolicyCount`);
    return {};
};
export const searchPolicy = (data) => {
    return middlewareEncryption(`/api/dealership/searchPolicy`, data);
};
export const getAllZm = () => {    
    return middlewareDecryption(`/api/affiliation/getAllZm`)
};

export const getReportByCompanyId = (data) => {
    return middlewareEncryption("/api/dealership/getReportByCompanyId", data)
};

export const getmMasterCount = () => {    
    return middlewareDecryption(`/api/dealership/getmMasterCount`)
};

export const getDealerMasterCount = (id) => {    
    return middlewareDecryption(`/api/dealership/getDealerMasterCount/${id}`)
    // return middlewareDecryption(`/api/dealership/getDealerMasterCount/12999`)
};

export const getActiveFuel = () => {    
    return middlewareDecryption(`/api/affiliation/getActiveFuel`)
};
export const getActiveTransmission = () => {    
    return middlewareDecryption(`/api/affiliation/getActiveTransmission`)
};
export const addOrUpdateDealerProductPreference = (id, data) => {
    return middlewareEncryption(`/api/dealership/addOrUpdateDealerProductPreference/${id}`, data)
};
export const getDmsAllowCompanyOnly = () => {    
    return middlewareEncryption(`/api/affiliation/getDmsAllowCompanyOnly`)
};


export const downloadPolicyCertificate = (id) => {    
    // id - certificate no
    return middlewareDecryption(`/api/dealership/downloadPolicyCertificate/${id}`)
};


export const downloadPolicyInvoice = (id) => {    
    // id - Invoice no

    return middlewareDecryption(`/api/dealership/downloadPolicyInvoice/${id}`)
};

export const getUserWalletCreditData = (id) => {
    return middlewareDecryption(`/api/affiliation/getUserWalletCreditData/${id}`,)
};

export const checkLowWalletBalance = (id) => {
    return middlewareDecryption(`/api/dealership/checkLowWalletBalanceAlert/${id}`)
};

export const getAllDealerWalletUpdateHistory = ( page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getAllDealerWalletUpdateHistory`,data)
};

// export const addOrUpdateDealerProductPreference = (id, data) => {
//     return middlewareEncryption(`/api/dealership/getAllDealerWalletUpdateHistory/${id}`, data)
// };

// export const getAllPortalOtp = ( page, rowsPerPage, columnFilters) => {
//     const data = createFilterData( columnFilters, page, rowsPerPage);
    
//     return middlewareEncryption(`/api/users/getAllPortalOtp/`,data)
// };

export const getAllPortalOtp = (payload,page,rowsPerPage,searchText,columnFilters,sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/users/getAllPortalOtp/`, combinedData);
};

export const getAllSecondaryDealerCode = (data) => {
    return middlewareEncryption(`/api/dealership/getAllSecondaryDealerCode`, data)
};

export const addSecondaryDealerCode = (data) => {
    return middlewareEncryption(`/api/dealership/addSecondaryDealerCode`, data)
};
export const createNewAddZone = (data) => {
    return middlewareEncryption("/api/users/addZone", data)
};
export const getAllZone = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/users/getAllZone`, data)
};
export const createNewAddRegion = (data) => {
    return middlewareEncryption("/api/users/addRegion", data)
};
export const getAllRegion = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/users/getAllRegion`, data)
};
export const getAllZoneByCompanyId = (id) => {
    return middlewareDecryption(`/api/users/getAllZoneByCompanyId/${id}`)
};
export const getAllRegionBySingleZoneId = (id) => {
    return middlewareDecryption(`/api/users/getAllRegionByZoneId/${id}`)
};

export const getAllRegionByZoneId = (data) => {
    const payload = {
        zone_id: data
    };
    return middlewareEncryption(`/api/users/getAllRegionByMultipleZoneId`, payload)
};

export const createBirthdayLogs = (data) => {
    return middlewareEncryption("/api/users/addBirthday", data)
};

    export const getBirthdayLogs = () => {
    return middlewareDecryption(`/api/users/getBirthdayLogs`);
};

export const editBirthdayLogs = (id, data) => {
    return middlewareEncryption(`/api/users/updateBirthdayLogs/${id}`, data)
};

export const birthdayBulkUpload = (data) => {
    return middlewareEncryption("/api/users/birthdayBulkUpload", data)
};

export const updatePaymentLog = (data) => {
    return middlewareEncryption("/api/payment/storeLog", data)
}
export const updatePass = (id) => {
    return middlewareEncryption(`/api/admin/updatePass/${id}`)
};
export const updateIRNStatus = (id, data) => {
    return middlewareEncryption(`/api/dealership/updateIRNStatus/${id}`, data)
};
export const getAllUsersDetailsByRole = () => {
    let body = {};
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    if (!role_id) {
        return toast.error('Role missing in route');
    }
    let dataType = 1;
    const currentURL = window.location.href;
    if (currentURL.includes('/affiliations/dealerships/users')) {
        dataType = 3;
    } else if (currentURL.includes('/affiliations/companies/users')) {
        dataType = 2;
    }
    body.adminFLAG = dataType;
    return middlewareEncryption(`/api/users/getAllUsersDetailsByRole/${role_id}`, body);
}

export const loginWithSAML = async () => {
    window.location.href = `${process.env.REACT_APP_SERVER_URL}/auth/saml`
    // window.location.href = `https://ts-stage-api.europassistance.in/auth/saml`
};

export const getAllDealerCommissionInvoices = (role) => {
    const params = new URLSearchParams();
    if (role) {
        params.set("role", String(role));
    }
    const query = params.toString();
    return middlewareDecryption(`/api/dealership/getAllDealerCommissionInvoices${query ? `?${query}` : ""}`)
};

export const updateDealerCommissionInvoiceStatus = (data) => {
    return middlewareEncryption(`/api/dealership/updateDealerCommissionInvoiceStatus`, data)
};

export const getDealerCommissionInvoiceByInvoiceNo = (id) => {
    return middlewareEncryption(`/api/dealership/getDealerCommissionInvoiceByInvoiceNo/${id}`)
};

export const downloadCommissionInvoice = (id) => {    
    return middlewareDecryption(`/api/dealership/downloadCommissionInvoice/${id}`)
};

export const getAllDealerCommissionInvoicesByDealer = (id) => {
    return middlewareEncryption(`/api/dealership/getAllDealerCommissionInvoicesByDealer/${id}`)
};
 
export const searchPayU = (data) => {
    return middlewareEncryption(`/api/dealership/searchPayU`, data);
};
export const updatePayUStatus = (id) => {
    return middlewareEncryption(`/api/dealership/updatePayUStatus/${id}`)
};

export const getRegionalManagersByZmId = (id) => {
    return middlewareDecryption(`/api/affiliation/getAllRmOfZm/${id}`);
};

export const getAllZmOfCompany = (id) => {
    return middlewareDecryption(`/api/affiliation/getAllZmOfCompany/${id}`);
};

export const getAllTargetAllotment = (id) => {
    return middlewareDecryption(`/api/affiliation/getAllTargetAllotment/${id}`);
};

export const getAllRmOfZMAndCompany = (data) => {
    return middlewareEncryption(`/api/affiliation/getAllRmOfZMAndCompany`, data)
};

export const createTargetAllotment = (data) => {
    return middlewareEncryption(`/api/affiliation/createTargetAllotment`, data)
};

export const getRsaSalesReport = (data) => {
    return middlewareEncryption(`/api/dealership/getRsaSalesReport`, data)
};

export const getAllDealerDetails = () => {
    return middlewareDecryption(`/api/dealership/getAllDealerDetails`,)
};


export const getZonalManagers = () => {
    return middlewareDecryption(`/api/affiliation/getAllZm`)
};

export const getAllSelectedcityByrole = (id) => {
    return middlewareDecryption(`/api/users/getAllSelectedcityByrole/${id}`)
}

export const getAllProductListByRole = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const filterNew = JSON.stringify(columnFilters ?? []);
    const sortString = JSON.stringify(sorting ?? []);
    const data = createFilterData(columnFilters, page, rowsPerPage);

    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    // return middlewareDecryption(`/api/product/getAllProductList?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortString}`)
    return middlewareEncryption(`/api/product/getAllProductListByRole/` + role_id, data)
};

export const getDealerCommissionSummary = (id) => {
    return middlewareEncryption(`/api/dealership/getDealerCommissionSummary/${id}`)
};


export const getPolicyDetailsByUser = (page = 0, rowsPerPage = 10, searchText = "", columnFilters = [], sorting = []) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';

    // if(ROLE.key == 'DEALERSHIP_MANAGER' || ROLE.key == 'DEALER_SALES_PERSON'){
    //     return middlewareDecryption(`/api/dealership/getPolicyDetailsByDealer/`+user?.dealerInfo?.dealership_id);
    // }
    //  Aa of now we will keep it, we want all data in one api only, handle in backend by session

    // return middlewareDecryption(`/api/dealership/getPolicyDetailsByRole/`+ role_id +'?pageNo='+page+'&pageSize='+rowsPerPage);

    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getPolicyDetailsByUser/` + role_id, data);

};

export const getMyActivitySummary = (data) => {
    return middlewareEncryption(`/api/dealership/getMyActivitySummary`, { timeInterval: data });
};

export const getPolicySalesByMonth = (companyId, month, userRole) => {
    return middlewareEncryption(`/api/dealership/getPolicySalesByMonth`, { company_id: companyId, month: month, userRole: userRole });
};

export const getPolicyStatusChart = (companyId, month, userRole) => {
    return middlewareEncryption(`/api/dealership/getPolicyStatusChart`, { company_id: companyId, month: month, userRole: userRole });
};

export const getPolicySalesByRM = (clientWiseSales, rmId) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getPolicySalesByRM`, { role: key, timeInterval: clientWiseSales, rmId: rmId });
};

export const getPolicySalesByZM = (clientWiseSales, zmId) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getPolicySalesByZM`, { role: key, timeInterval: clientWiseSales, zmId: zmId });
};

export const getMyRequestGraph = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.role_id ? ROLE.role_id : '';
    return middlewareEncryption(`/api/dealership/getMyRequestGraph`, { role: key, timeInterval: data });
};

export const getAllRM = () => {
    return middlewareDecryption(`/api/affiliation/getAllRM`)
};

export const getAllRmOfZm = (data) => {
    return middlewareEncryption(`/api/affiliation/getAllRmOfZm`, data)
};

export const companyHasRoleOfZmRm = (data) => {
    return middlewareEncryption(`/api/affiliation/companyHasRoleOfZmRm`, data)
};

export const dealerHasRoleOfZmRm = (data) => {
    return middlewareEncryption(`/api/affiliation/dealerHasRoleOfZmRm`, data)
};


export const getZMDashboardData = (data) => {
    return middlewareEncryption(`/api/dealership/getZMDashboardData`, data)
};

export const getRMDashboardData = (data) => {
    return middlewareEncryption(`/api/dealership/getRMDashboardData`, data)
};


export const getAllZMByLocation = (data) => {
    return middlewareEncryption(`/api/dealership/getAllZMByLocation/`, data);
};

export const getAllRMByLocation = (data) => {
    return middlewareEncryption(`/api/dealership/getAllRMByLocation/`, data);
};

export const getAllDealersAndCompanyZRM = (data) => {
    return middlewareEncryption(`/api/dealership/getAllDealersAndCompanyZRM`, data);
};

export const getZMRankingData = (data) => {
    return middlewareEncryption(`/api/dealership/getZMRankingData`, data);
};

export const getRMRankingData = (data) => {
    return middlewareEncryption(`/api/dealership/getRMRankingData`, data);
};

export const getAllRMRankingDataOfZM = (data) => {
    return middlewareEncryption(`/api/dealership/getAllRMRankingDataOfZM`, data);
};

export const getRank = () => {
    return middlewareDecryption(`/api/dealership/getRank`);
}

export const getRankRm = () => {
    return middlewareDecryption(`/api/dealership/getRankRm`);
}

export const getAssignRoleToDealerDetails = (data) => {
    return middlewareEncryption(`/api/dealership/getAssignRoleToDealerDetails`, data);
};

export const getAllTargetReportOfCompany = (data) => {
    return middlewareEncryption(`/api/dealership/getAllTargetReportOfCompany`, data);
};
export const getAllZoneList = () => {
    return middlewareDecryption(`/api/users/getAllZoneList`)
};

export const getActiveCompanyByLocation = (data) => {
    return middlewareEncryption(`/api/affiliation/getActiveCompanyByLocation`, data)
};

export const getClientDealerTargetAndAchievement = (data) => {
    return middlewareEncryption(`/api/affiliation/getClientDealerTargetAndAchievement`, data)
};


export const getTargetWisePerformanceReport = () => {
    return middlewareDecryption(`/api/dealership/getTargetWisePerformanceReport`)
};

export const getRoleAssineLocation = (data) => {
    return middlewareEncryption(`/api/dealership/getRoleAssineLocation`, data);
};

export const getAllHelpDeskDocument = () => {
    return middlewareDecryption(`/api/users/getAllHelpDeskDocument`)
};

export const pushPolicyToEzAuto = (data) => {
    return middlewareEncryption(`/api/dealership/pushPolicyToEzAuto`, data);
}

// PayU BC Sync
export const checkDealerSyncStatus = (id) => {
    console.log("Inside the dealershipcheckDealerSyncStatus API");
    return middlewareDecryption(`/api/dealership/dealershipcheckDealerSyncStatus/${id}`);
}

export const fetchDealerDocDetails = (data) => {
    return middlewareEncryption(`/api/dealership/fetchDealerDocDetails`, data);
}

export const getProductTermsAndConditionPdf = (data) => {
    return middlewareEncryption(`/api/product/getProductTermsAndConditionPdf`, data);
}

export const fetchClientEncryptedLogo = (data) => {
    return middlewareEncryption(`/api/dealership/fetchClientEncryptedLogo`, data);
}

export const getKycDocEnycryptedFile = (data) => {
    return middlewareEncryption(`/api/dealership/getKycDocEnycryptedFile`, data);
}

export const encryptingFile = (data) => {
    return middlewareEncryption(`/api/dealership/encryptingFile`, data);
}

export const updateSecondaryDealerCode = (data, leadId) => {
    return middlewareEncryption(`/api/dealership/updateSecondaryDealerCode`, data)
};

// update ezauto scheme name for product
export const updateProductSchemeName = (data) => {
    return middlewareEncryption(`/api/product/updateProductSchemeName`, data);
}

export const getProductSchemeName = () => {
    return middlewareDecryption(`/api/product/getProductSchemeName`);
}

export const updateDealerDetails = (data) => {
    return middlewareEncryption(`/api/dealership/updateDealerDetails`, data);
}

export const getCompanyByRole = (data) => {
    return middlewareEncryption(`/api/dealership/getCompanyByRole`, data);
}

export const getMyRequestVisitingReport = (data) => {
    return middlewareEncryption(`/api/affiliation/getMyRequestVisitingReport`, data);
};

export const getVisitingReportByRole = (data) => {
    return middlewareEncryption(`/api/affiliation/getVisitingReportByRole`, data);
};

export const getAllTargetData = (data) => {
    return middlewareEncryption(`/api/affiliation/getAllTargetData`, data);
};

export const setTarget = (data) => {
    return middlewareEncryption(`/api/affiliation/setTarget`, data);
};

export const getClinetTargetData = (data) => {
    return middlewareEncryption(`/api/affiliation/getClinetTargetData`, data);
};

export const getAllTargetReportData = (data) => {
    return middlewareEncryption(`/api/affiliation/getAllTargetReportData`, data);
};

export const getAllTargetReportDataByRole = (data) => {
    return middlewareEncryption(`/api/affiliation/getAllTargetReportDataByRole`, data);
};

export const getCompayDetaisByRole = (data) => {
    return middlewareEncryption(`/api/affiliation/getCompayDetaisByRole`, data);
};

export const editIncentive = (data) => {
    return middlewareEncryption(`/api/affiliation/editIncentive`, data);
};

export const setIncentive = (data) => {
    return middlewareEncryption(`/api/affiliation/setIncentive`, data);
};

export const getAllIncentive = () => {
    return middlewareEncryption(`/api/affiliation/getAllIncentive`);
};

export const getDealerKycReport = () => {
    return middlewareEncryption(`/api/affiliation/getDealerKycReport`);
};

export const getAllStateForRole = () => {
    return middlewareDecryption(`/api/users/getAllStateForRole`);
}

export const getInclusionProductForHero = () => {
    return middlewareDecryption(`/api/product/getInclusionProductForHero`);
};

export const heroInclusionBulkPolicy = (data) => {
    return middlewareEncryption("/api/dealership/heroInclusionBulkPolicy", data)
};

export const searchPolicyGlobal = (data) => {
    return middlewareEncryption(`/api/dealership/searchPolicyGlobal`, data);
};

export const editUserLocations = (id, data) => {
    return middlewareEncryption(`/api/admin/editUserLocations/${id}`, data)
};

export const getProgramStatusMapping = () => {
    return middlewareDecryption(`/api/affiliation/getProgramStatusMapping`)
}

export const getReportingManagers = (userId) => {
    return middlewareDecryption(`/api/users/getReportingManagers/${userId}`);
}

export const getDashboardMasterCount = (data) => {
    const user = getFromLocalStorage("user");
    data.userId = user?.user_id || "";
    return middlewareEncryption(`/api/dealership/getDashboardMasterCount`, data);
}

export const getAllFieldType = (payload, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };

    console.log("combinedData ===>", combinedData);

    return middlewareEncryption(`/api/affiliation/getAllFieldType`, combinedData);
}

export const createFieldOption = (data) => {
    return middlewareEncryption(`/api/affiliation/createFieldOption`, data);
}

export const getFieldOption = (data) => {
    return middlewareEncryption(`/api/affiliation/getFieldOption`, data);
}

export const updateFieldOption = (data) => {
    return middlewareEncryption(`/api/affiliation/updateFieldOption`, data);
}

export const deleteFieldOption = (data) => {
    return middlewareEncryption(`/api/affiliation/deleteFieldOption`, data);
}

export const createFieldType = (data) => {
    return middlewareEncryption(`/api/affiliation/createFieldType`, data);
}

export const createNewLeads = (data) => {
    return middlewareEncryption("/api/affiliation/addLeads", data)
};
//Meetings Module
export const creatNewMeetings = (data) => {
    return middlewareEncryption("/api/affiliation/addMeetings", data)
};

// export const getAllBrand = (page, rowsPerPage, searchText, columnFilters, sorting) => {
//     const data = createFilterData(columnFilters, page, rowsPerPage);
//     return middlewareEncryption(`/api/affiliation/getAllBrand`, data)
// };

export const getAllLeads = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const role = getFromLocalStorage("ROLE").key;
    const user = getFromLocalStorage("user");
    // const role = "NM"
    data.role = role;
    data.userId = user?.user_id || null;
    return middlewareEncryption("/api/affiliation/getAllLeads", data)
};

export const getAllMeetings = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const role = getFromLocalStorage("ROLE").key;
    const user = getFromLocalStorage("user");
    data.roleName = role;
    data.userId  = user?.user_id || null;
    return middlewareEncryption("/api/affiliation/getAllMeetings", data)
};

// Meeting Persons Master
export const getMeetingPersons = () => {
    return middlewareEncryption("/api/affiliation/getMeetingPersons", {});
};

export const createMeetingPerson = (data) => {
    return middlewareEncryption("/api/affiliation/createMeetingPerson", data);
};

export const getLeadSpocByLeadId = (leadId) => {
    return middlewareEncryption("/api/affiliation/getLeadSpoc", { lead_id: leadId });
};

export const getOptionDetailsById = (data) => {
    return middlewareEncryption("/api/affiliation/getOptionDetailsById", data)
};

export const updateStatusOfFieldType = (data) => {
    return middlewareEncryption("/api/affiliation/updateStatusOfFieldType", data)
};

export const updateStatusOfFieldOption = (data) => {
    return middlewareEncryption("/api/affiliation/updateStatusOfFieldOption", data)
}

export const updateLeadAssign = (data) => {
    return middlewareEncryption("/api/affiliation/updateLeadAssign", data)
}

export const getAllBDMUser = () => {
    return middlewareDecryption("/api/affiliation/getAllBDMUser")
}

export const assignLeadHistory = (data) => {
    return middlewareEncryption("/api/affiliation/assignLeadHistory", data)
}

export const updateLead = (data, leadId) => {
    return middlewareEncryption(`/api/affiliation/updateLead/${leadId}`, data)
};

export const updateMeeting = (data, leadId) => {
    return middlewareEncryption(`/api/affiliation/updateMeeting/${leadId}`, data)
};

export const fetchLeadClientNames = () => {
    return middlewareDecryption(`/api/dealership/getAllLeadClients`);
}

export const getAllUsersByRoleId = (roleId) => {
    return middlewareDecryption(`/api/users/getAllUsersByRoleId/${roleId}`);
}


// NCB / dealer-QR self-renewal
export const getProductSelfRenewalConfig = (id) => {
    return middlewareDecryption(`/api/product/getProductSelfRenewalConfig/${id}`);
};

export const downloadCreditNote = (id) => {
    return middlewareDecryption(`/api/policy-self-renewal/downloadCreditNote/${id}`)
};

export const generateQrCode = (data) => {
    return middlewareEncryption(`/api/dealership/generateQrCode`, data);
};

export const onlinePolicyCancellation = (data) => {
    return middlewareEncryption(`/api/dealership/onlinePolicyRefundApi`, data)
};

// Dealer commission claim for self-renewed ("Online Link") policies
export const getDealershipsByCompanyId = (id) => {
    return middlewareDecryption(`/api/dealerClaim/dealerships/${id}`);
};

export const getUnclaimedOnlineLinkPolicies = (
    page = 1,
    rowsPerPage = 10,
    columnFilters = [],
    role,
    dealershipId
) => {
    const params = new URLSearchParams({
        pageNo: String(page),
        pageSize: String(rowsPerPage),
    });

    if (dealershipId) {
        params.set("dealership_id", String(dealershipId));
    }

    if (role) {
        params.set("role", String(role));
    }

    const allowedFilters = ["dealer_name", "dealer_code", "product_name", "policy_number"];
    columnFilters.forEach(({ id, value }) => {
        if (allowedFilters.includes(id) && value != null && String(value).trim() !== "") {
            params.set(id, String(value));
        }
    });

    return middlewareDecryption(`/api/dealerClaim/unclaimedOnlineLinkPolicies?${params.toString()}`);
};
export const submitDealerClaims = (data) => {
    return middlewareEncryption("/api/dealerClaim/submitClaims", data);
};

export const getHSNCodeDetails = (companyId) => {
    return middlewareDecryption(`/api/dealerClaim/hsnCode/${companyId}`);
};

export const checkInvoiceExists = (invoiceNo) => {
    return middlewareDecryption(`/api/dealerClaim/checkInvoiceExists/${invoiceNo}`)
};

export const downloadCommissionInvoicePdf = (id, integration_document_no) => {
    return middlewareDecryption(`/api/dealership/downloadCommissionInvoicePdf/${id}/${integration_document_no}`);
};
